<template>
    <div class='container_box'>
      <div class="wrapDiv">
      <img src="https://oss.81lianpin.com/picture/5e/23/fb/ad308101e81747735a5867cdc53055ed.png">
    </div>
    </div>
  </template>
  <script>
  export default {
    name: 'activityPage',
    data() {
      return {
       
      };
  
    
    },
    methods: {
      
    },
    }
  </script>
  <style scoped>
     .wrapDiv{
    background: #f0f2f5;
    position: relative;
    height: 100vh;
    width: 100%;
  }
  .wrapDiv img{
    width: 1428px;
    height: 669px;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  </style>


// WEBPACK FOOTER //
// src/page/stopService.vue